<div class="container-fluid" >
  <div class="row top10">
    <div class="col-xs-12">
      <h3>IBN Line Items for Inventory</h3>
    </div>
  </div>

  <hr style="margin-top: 2px; margin-bottom: 2px" />

  <aims-common-table
    id="aims-table-in-table"
    [dataSource]="lineItemsForInventory | async"
    [header]="header"
    [permissions]="tablePermissions"
    [stickyHeader]="true">

    <aims-common-table-dynamic-row id="inventory">
      <ng-template viewMode let-element let-idx="idx">
      <aims-common-button-mini *ngIf="permissions.canRead(permissions.ComponentID.InboundNotice)"
          title="Inventory Item(s)"
          aria-label="Inventory Items"
          (click)="inventoryItem(element)">
        <mat-icon color="primary">archive</mat-icon>
      </aims-common-button-mini>
      </ng-template>
    </aims-common-table-dynamic-row>

    <aims-common-table-dynamic-row id="ibnlink">
      <ng-template viewMode let-element let-idx="idx">
          <a style="color: blue"
            routerLink="/logistics/inboundNotice/{{element.shippingHeaderId}}"><u>{{ element.shippingHeaderId }}</u>
          </a>
      </ng-template>
    </aims-common-table-dynamic-row>

    <aims-common-table-dynamic-row id="polink">
      <ng-template viewMode let-element let-idx="idx">
              <a style="color: blue"
                routerLink="/logistics/{{
                  element.po || element.reqLineItem
                    ? 'requisition/' +
                      (element.po?.reqId || element.reqLineItem?.reqId)
                    : 'shippingRequest/' +
                      element.shippingRequestItem?.shippingRequestHdrId
                }}" ><u>{{
                  element.po?.poId ||
                    element.reqLineItem?.reqId ||
                    element.shippingRequestItem?.shippingRequestHdrId
                }}</u></a >
      </ng-template>
    </aims-common-table-dynamic-row>

    <aims-common-table-dynamic-row id="lineno">
      <ng-template viewMode let-element let-idx="idx">
              {{
                element.po?.poLnNo.toString() ||
                  element.reqLineItem?.lineNumber.toString()
              }}
      </ng-template>
    </aims-common-table-dynamic-row>

    <aims-common-table-dynamic-row id="nomenclature">
      <ng-template viewMode let-element let-idx="idx">
              {{
                element.po?.poLnDesc ||
                  element.reqLineItem?.nomenclature ||
                  element.shippingRequestItem?.nomenclature
              }}
      </ng-template>
    </aims-common-table-dynamic-row>

    <aims-common-table-dynamic-row id="manfpartno">
      <ng-template viewMode let-element let-idx="idx">
            {{ element.po?.manufPartId || element.reqLineItem?.partNumber }}
      </ng-template>
    </aims-common-table-dynamic-row>

    <aims-common-table-dynamic-row id="vendpartno">
      <ng-template viewMode let-element let-idx="idx">
            {{ element.po?.vendPartId || element.reqLineItem?.vendPartNumber }}
      </ng-template>
    </aims-common-table-dynamic-row>

    <aims-common-table-dynamic-row id="unitofissue">
      <ng-template viewMode let-element let-idx="idx">
            {{
              element.po?.poLnUmCd ||
              element.reqLineItem?.ui ||
              element.shippingRequestItem?.ui
            }}
      </ng-template>
    </aims-common-table-dynamic-row>

    <aims-common-table-dynamic-row id="totalqty">
      <ng-template viewMode let-element let-idx="idx">
            {{
              element.po?.ordQty ||
              element.reqLineItem?.qtyOrdered ||
              element.shippingRequestItem?.qtyReqShipped
            }}
      </ng-template>
    </aims-common-table-dynamic-row>

    <aims-common-table-dynamic-row id="hazmat">
      <ng-template viewMode let-element let-idx="idx">
          <mat-checkbox disabled [checked]="element.hazmat"></mat-checkbox>
      </ng-template>
    </aims-common-table-dynamic-row>

    <aims-common-table-dynamic-row id="rcvdby">
      <ng-template viewMode let-element let-idx="idx">
            {{
              element.receivedById
                | getText: "employeeId":"fullName":employeeValues
            }}
      </ng-template>
    </aims-common-table-dynamic-row>
  </aims-common-table>

  <ng-container *ngIf="showInventoryItem()">
    <aims-form>
      <app-inventory-item
        [lineItem]="currentLogShippingCommLi"
        (LineItemInventoriedEvent)="handleLineItemInventoried()"
        (InventoryItemClearedEvent)="clearItem()">
      </app-inventory-item>
    </aims-form>
  </ng-container>
</div>

<aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"> </aims-spinner>
